export enum ConfigFieldEnum {
    apiKey = 'apiKey',
    environment = 'environment',
    idSchema = 'idSchema',
    clientId = "clientId",
    lang = 'lang',
    oddClient = 'oddClient',
    authProvider = 'authProvider',
    cookieToken = 'cookieToken'
}